import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import SignIn from '@/features/auth/sign-in'

const signInSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
  passwordReset: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/(auth)/sign-in')({
  component: SignIn,
  validateSearch: signInSearchSchema,
})
